export const whoAreWe = {
	title: 'Kto sme',
	content:
		'Spoločnosť PaRELI s.r.o. bola založená v roku 2013 s cieľom vytvoriť „úspešný projekt“, kde môžeme\n' +
		'naďalej rozvíjať svoje pracovné skúsenosti v oblasti tvorby projektovej dokumentácie a neustále\n' +
		'napredovať. Ideou spoločnosti je „nevnímať túto činnosť ako prácu ale ako poslanie“ s úmyslom priniesť\n' +
		'na trh niečo nové. Zdokonaľovaním poskytovaných služieb počet zákaziek úmerne narastal, čo viedlo k\n' +
		'rozšíreniu kolektívu, ktorý dnes činí 9 projektantov. Výber kolegov berieme za hlavnú príčinu úspechu,\n' +
		'pretože každý jeden reprezentuje našu spoločnosť a behom krátkeho okamihu dokáže jednotlivec zničiť to,\n' +
		'čo sme všetci budovali roky. Preto v spoločnosti môže pôsobiť len ten, ktorý je stotožnený s našou\n' +
		'ideou.\n' +
		'Spoločnosť PaRELI s.r.o. sa dlhodobo podieľa na budovaní panorámy miest a obcí na Slovensku, kde\n' +
		'spolupracujeme aj s najväčšími projekčnými kanceláriami a developermi pôsobiacimi na SR a v zahraničí.\n',
};
